const prep = string => {
  return encodeURIComponent(string.toLowerCase()).replace(/%20/g, "+");
};

const addQuerystringSuffix = link => {
  return link.includes("?") ? `${link}&` : `${link}?`;
};

export const addAnalyticsDataToLink = ({
  link,
  gender,
  labelPath,
  headerTopBarHidden
}) => {
  if (!link) {
    return null;
  }

  if (!gender) {
    return link;
  }

  /* istanbul ignore next */
  if (labelPath.includes("Marketplace")) {
    if (headerTopBarHidden) {
      link += "|emf82v2";
    } else {
      link += "|emf82v1";
    }
  }

  if (labelPath.length === 6) {
    const [, , , section, container] = labelPath;

    if (section && container) {
      return `${addQuerystringSuffix(link)}nlid=${prep(gender)}|${prep(
        section
      )}|${prep(container)}`;
    }
  }

  if (labelPath.length === 4) {
    const [, , section] = labelPath;

    if (section) {
      return `${addQuerystringSuffix(link)}nlid=${prep(gender)}|${prep(
        section
      )}`;
    }
  }

  return link;
};
